class ChildrenPicker extends HTMLElement {
  constructor() {
    super();
    // Get bundle product handles from the 'handles' attribute
    this.handles = this.getAttribute('handles') ? this.getAttribute('handles').split(',') : [];
    // Find the product details element on the page
    this.productDetailsElement = document.querySelector('.product-main .product__content [data-product-details]') || document.querySelector('[data-drawer] [data-product-details]');
    // Array to store the HTML of the fetched bundle products
    this.productHtml = [];

    this.errors = [];
    // Initialize the component
    this.init();
  }

  async init() {
    // Fetch the HTML of the children products in the bundle
    await this.fetchChildrenProductsHtml();
    // Render the HTML of the bundle products
    this.productHtml.map(html => this.innerHTML += html);

    this.variantSelects = Array.from(this.querySelectorAll('variant-selects'))

    document.addEventListener('product:initVariant', (e) => {
      let index = 0;
      this.variantSelects.forEach((select) => {
        if (select.variantData.length === 1) {
          select.querySelector('select#Option--1').value = select.variantData[0].option2;
        } else {
          select.querySelector('select#Option--1').value = e.detail.options[index];
          if (select.currentVariant.option2 !== e.detail.options[index]) {
            select.dispatchEvent(new Event('change'))
          }
          index++;
        }
      });
    })

    // Dispatch a custom event indicating that the children products are ready
    document.dispatchEvent(new CustomEvent('product:childrenReady', {
      detail: this.variantSelects.map((select) => select.currentVariant)
    }));

    // Initialize the modals and drawers again
    Woolman.ModalsAndDrawers.init();
    // Format and rearrange the product details on the page
    this.formatProductDetails();
    // Check and update the add to cart button status
    this.checkAddButton();

    document.addEventListener('product:variantChangeBundle', (e) => {
      document.dispatchEvent(new CustomEvent('product:childrenChanged', {
        detail: this.variantSelects.map(
          (select) => select.variantData.length === 1
            ? false
            : select.currentVariant
        ).filter((variant) => variant !== false)
      }));
    });
  }

  async fetchChildrenProductsHtml() {
    const promises = [];

    const rootUrl = window.Shopify.routes.root == '/' ? '/' : window.Shopify.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
    this.handles.forEach((productHandle) => {
      promises.push(fetch(`${rootUrl}products/${productHandle}?view=bundle-child-v2`));
    });

    // Wait for all the promises to settle and get the HTML of the bundle products
    const settledPromises = await Promise.allSettled(promises);

    for (const promise of settledPromises) {
      try {
        const res = await promise.value;
        if (res.status !== 200) { throw res.status }
        const html = await res.text();

        this.productHtml.push(html);
      } catch(err) {
        console.error(err);
        this.errors.push(err);
      }
    }
  }

  formatProductDetails() {
    if (!this.productDetailsElement) return;

    this.querySelectorAll('[data-product-details]').forEach((element) => {
      this.productDetailsElement.innerHTML += element.innerHTML
      element.parentElement.remove();
    });
  }

  checkAddButton() {
    const productForm = document.getElementById(`product-form-${this.dataset.productId}`);
    if (!productForm) return;

    const variantSelects = Array.from(this.querySelectorAll('variant-selects')).map((select) => select.currentVariant);

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (variantSelects.some(variant => !variant.available) || this.errors.length > 0) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = window.variantStrings.soldOut;

      return;
    }

    addButton.removeAttribute('disabled');
    addButtonText.textContent = window.variantStrings.addToCart;
  }
}

customElements.define('children-picker', ChildrenPicker);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.productTitle = this.dataset.productTitle;

    this.updateOptions();
    this.updateMasterId();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();

    this.updateAddBtn();
    if (this.currentVariant) {
      this.renderProductInfoDebounce();
      this.updateMedia();
    }

    const event = new CustomEvent('product:variantChangeBundle', {
      detail: this.currentVariant,
    });

    document.dispatchEvent(event);
  }

  updateAddBtn() {
    const variantSelects = Array.from(document.querySelectorAll('variant-selects')).map((select) => select.currentVariant);
    const currentVariantPicker = this.closest('children-picker');
    const childrenPickerid = currentVariantPicker.getAttribute('data-product-id')
    const productForm = document.getElementById(`product-form-${childrenPickerid}`)

    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    addButton.removeAttribute('disabled');
    addButtonText.textContent = window.variantStrings.addToCart;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const currentVariantImage = this.closest('.bundle-child').querySelector(`.bundle-child__image[data-variant-id="${this.currentVariant.id}"]`);
    if (!currentVariantImage) return;

    const productImages = this.closest('.bundle-child').querySelectorAll(`.bundle-child__image[data-product-id="${this.dataset.productId}"]`);

    productImages.forEach(image => {
      image.setAttribute('hidden', 'true');
    });

    currentVariantImage.removeAttribute('hidden');
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  renderProductInfoDebounce() {
    if (this.fetchTimeout) {
      clearTimeout(this.fetchTimeout);
    }

    this.fetchTimeout = setTimeout(() => {
      this.renderProductInfo();
    }, 500);
  }

  renderProductInfo() {
    const productDetailsElement = document.querySelector('.product-main .product__content [data-product-details]') || document.querySelector('[data-drawer] [data-product-details]');

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&view=bundle-child-v2`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // Render details content
        const newProductDetails = html.querySelector('[data-product-details]');
        productDetailsElement.querySelector(`[data-product-id="${this.productId}`).innerHTML = newProductDetails.innerHTML;
      });
  }
}

customElements.define('variant-selects', VariantSelects);

class BundlePrice extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('product:parentVariantChanged', this.updateBundlePrice);
  }

  updateBundlePrice (e) {
    const priceElements = document.querySelectorAll('[data-bundle-price] .price-item--regular');

    if (priceElements.length === 0) return;

    const variant = e.detail

    let priceToSet = variant.price;
    if (variant.compare_at_price_cents && variant.compare_at_price_cents > variant.price_cents) {
      priceToSet = variant.compare_at_price
    }

    for (const priceElement of priceElements) {
      priceElement.innerHTML = priceToSet
    }

    const priceItemSaleElement = document.querySelector('[data-bundle-price] .price-item--sale')
    if (priceItemSaleElement) {
      priceItemSaleElement.innerHTML = variant.price
    }
  }
}

customElements.define('bundle-price', BundlePrice);

const Photoswipe = {
  attempts: 0,

  selectors: {
    images: '.photoswipe__image'
  },

  init: function() {
    document.querySelectorAll('.photoswipe__image').forEach(trigger => {
      trigger.addEventListener('click', this.downloadAndMount.bind(this));
    });
  },

  downloadAndMount: function(evt) {
    if (this.attempts >= 10) { return };
    this.attempts++;
    const existingScript = document.querySelector(`script[src="${theme.assets.photoswipe}"]`);

    // If we are already processing one slider, wait a while and try again.
    if (window.processingPhotoswipe) {
      setTimeout(this.downloadAndMount.bind(this), 200);
      return;
    }

    // Photoswipe script was already found in document, proceed to immediately mount slider
    if (existingScript) {
      this.showZoom(evt);
      return;
    }

    // Photoswipe script was not found in document, download it and wait for it to load, then show zoom
    window.processingPhotoswipe = true;

    const script = document.createElement('script');
    script.setAttribute('defer', 'true');
    script.setAttribute('async', 'true');
    script.src = theme.assets.photoswipe;
    document.body.append(script);

    script.addEventListener('load', () => {
      this.showZoom(evt)
    })
  },

  showZoom: function(evt) {
    const target = evt.currentTarget || evt.target;
    this.targetElement = target.closest('[data-photoswipe-parent]');
    this.items = this.getImageData();

    this.initGallery(this.items, target.dataset.index || 1);
    window.processingPhotoswipe = false;
  },

  getImageData: function() {
    this.images = this.targetElement.querySelectorAll(this.selectors.images)

    const items = [];

    this.images.forEach(el => {
      const item = {
        src: el.getAttribute('data-photoswipe-src'),
        w: parseInt(el.getAttribute('data-photoswipe-width')),
        h: parseInt(el.getAttribute('data-photoswipe-height')),
        initialZoomLevel: 0.5
      }

      items.push(item);
    });

    return items;
  },

  initGallery: function(items, index) {
    const pswpElement = document.querySelectorAll('.pswp')[0];

    const options = {
      allowPanToNext: false,
      captionEl: false,
      closeOnScroll: false,
      counterEl: false,
      history: false,
      index: parseInt(index) - 1,
      pinchToClose: false,
      preloaderEl: false,
      shareEl: false,
      tapToToggleControls: false
    }

    this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    this.gallery.init();
  }
};
Photoswipe.init()
